export default __webpack_public_path__ + "static/media/gp-title-en.605a7564.webp";